// BUTON WITH CUSTOMISED COLOR 

import React from 'react';
import './ActionButton.css';
//type primary means default background full filled buttton other wise outlined button
const ActionButton = ({ label, onClick, btnType, btnDisable = false }) => {
    return (
        <button
            disabled={btnDisable}
            type='button'
            onClick={onClick}
            className={btnType === `primary` ? `ActionButton-primary` : btnType === `outlined` ? 'ActionButton-outlined' : 'ActionButton-text'}
        >
            {label}
        </button>
    );
};

export default ActionButton;
